module.exports = (__webpack_require__(9))(585);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/antd/es/tag/index.js from dll-reference antd_library
// module id = 743
// module chunks = 42